import styled from 'styled-components/macro';

export const Value = styled.h2`
    color: ${({ value }) =>
        value === 0 ? '#000' : value > 0 ? '#8C2F22' : '#107000'};
    font-weight: normal;
    margin-right: 5px;
    font-size: 25px;
`;

export const Observation = styled.div`
    font-family: Roboto;
    margin-top: -70px;
    font-size: 19.5px;
    color: #4f4e4e;
    font-weight: 300;
    letter-spacing: 0.8px;
    display: grid;
    justify-content: center;
    @media screen and (max-width: 700px) {
        margin-top: -20px;
    }
`;

export const Text = styled.div`
    font-family: Roboto;
    display: flex;
    font-size: 22px;
    text-transform: lowercase;
    font-weight: 400;
    letter-spacing: 0.5px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const Empty = styled.div`
    color: #a3a3a3;
    font-size: 22px;
    align-self: center;
    margin: 0 auto;
    letter-spacing: 2px;
    font-weight: 400;
`;
